import React, { useMemo } from 'react';
import CensusStatistics from 'components/common/census/census-review/CensusStatistics';
import CensusReviewPageStore, {
  QuoteChecklistCensusReviewPageStoreContext,
  useQuoteChecklistCensusReviewPageStore,
} from 'store/pages/quote/add-employees/census-review/pageStore';
import { observer } from 'mobx-react-lite';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { RouteV2Id } from 'routes/routesConfigV2';

/* TESTING_POLICY: CYPRESS_ONLY */

const PageContent: React.FC = observer(() => {
  const pageStore = useQuoteChecklistCensusReviewPageStore();
  return <CensusStatistics pageStore={pageStore} />;
});

const CensusReviewPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();
  const pageStore = useMemo(
    () => new CensusReviewPageStore({ groupId, enrollmentPeriodId: periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <QuoteChecklistCensusReviewPageStoreContext.Provider value={pageStore}>
      <PageInFlowNoSidebarLayout
        contentWidth="standard"
        domainParams={{ groupId, periodId, cartId }}
        pageId={RouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_REVIEW}
      >
        <PageContent />
      </PageInFlowNoSidebarLayout>
    </QuoteChecklistCensusReviewPageStoreContext.Provider>
  );
};

export default CensusReviewPage;
